<template>
  <div class="news-list">
    <div class="main">
      <Datatable url="/Member/RZJInfoCenter/InformationList" field="InformationList" v-slot="{item}" viewtype="list" :tip="$t('msg.m117')">
        <div class="list">
          <div class="list-l">
            <router-link :to="{name:'newsDetail',query:{id:item.Id}}"><img :src="item.SmallImg" :alt="item.Subject"></router-link>
          </div>
          <div class="list-r">
            <h3 class="title"><router-link :to="{name:'newsDetail',query:{id:item.Id}}">{{item.Subject}}</router-link></h3>
            <p
              class="p-c"
            >{{item.Generalize}}</p>
            <p class="desc">
              <i class="icon"></i>
              <span class="mar-r30">{{item.CreatedAt}}</span>
              <span>{{$t('other.w81')}}</span>
            </p>
          </div>
        </div>
      </Datatable>
    </div>
  </div>
</template>

<script>
import Datatable from "@/components/datatable"
export default {
  components:{Datatable},
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.news-list {
  margin-top: 58px;
  min-height: 600px;
  .main {
    width: 800px;
    margin: 0 auto;
    .mar-r30{
      margin-right: 30px;
    }
    .list {
      padding-bottom: 30px;
      border-bottom: 1px solid #d7d7d9;
      margin-bottom: 30px;
      display: flex;
      .list-l {
        width: 220px;
        height: 150px;
        background: #ccc;
        margin-right: 20px;
      }
      .list-r {
        color: #7b7b7c;
        width: 560px;
        .title {
          font-size: 18px;
          color: #232325;
          margin-bottom: 10px;
          a{
            color: #232325;
            &:hover{
              text-decoration: underline
            }
          }
        }
        .p-c {
          font-size: 14px;
          height: 60px;
          margin-bottom: 28px;
        }
        .desc {
          color: #7b7b7c;
          display: flex;
          align-items: center;
          .icon {
            display: inline-block;
            width: 12px;
            height: 12px;
            background: url("../../assets/assetcenter/news_times.png") no-repeat;
            background-size: cover;
            margin-right: 5px;
          }
        }
      }
    }
  }
}
</style>
